<template>
  <Breadcrumb :home="home" :model="items" class="mb-3"/>

 <IndustryNotFoundComponent />   

  <div class="grid">
		<div class="col-12">
            <div class="card">
                <Toast/>
                <Error :errors="errors"/>

                <Create @submit="getDataTable()" ref="create"/>

                <TagSlotComponent :total="user?.userweb_status?.total_data_project" :max="user?.userweb_status?.max_project" /> 

                <DataTable :value="dataTable" :resizableColumns="true" columnResizeMode="fit" responsiveLayout="scroll" :loading="loading" dataKey="number" @sort="onSort($event)">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <div>
                                <Button :loading="loadingExcel" label="Export Excel" icon="pi pi-file-excel" class="p-button p-button-success mr-2 my-1 inline-block" @click="exportExcelCSV('xlsx')"/>
                                <Button :loading="loadingCsv" label="Export CSV" icon="pi pi-file-excel" class="p-button p-button-success mr-2 my-1 inline-block" @click="exportExcelCSV('csv')"/>
                            </div>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="search" placeholder="Search..." @keyup.enter="getDataTable" />
                            </span>
                        </div>
                    </template>
                    <Column field="number" header="#" :style="{width:'20px'}" >
                        <template #body="slotProps">
                        {{ slotProps.data.number }}
                        </template>
                    </Column>
                    <Column field="project_code" header="Project Code">
                        <template #body="slotProps">
                            <!-- <i><a style="cursor: pointer;" @click="detailItem(slotProps.data.project_id,'detail')">{{slotProps.data.project_code}} <br>
                            <small >Click to Calculation and Mapping</small ></a></i> -->

                            {{slotProps.data.project_code}} <br>
                            <i><a style="cursor: pointer;" @click="detailItem(slotProps.data.project_id,'detail')"><small >Click to Calculation and Mapping</small ></a></i>
                        </template>
                    </Column>
                    <Column field="project_name" header="Project Name">
                        <template #body="slotProps">
                            {{slotProps.data.project_name}}
                        </template>
                    </Column>
                    <Column field="project_periode_label" header="Period">
                        <template #body="slotProps">
                            {{slotProps.data.project_periode_label}}
                        </template>
                    </Column>
                    <Column field="project_location" header="Location">
                        <template #body="slotProps">
                            {{slotProps.data.project_location}}
                        </template>
                    </Column>
                    <Column field="distributor_coordinate" header="Distributor Coordinate">
                        <template #body="slotProps">
                            {{slotProps.data.distributor_coordinate}}
                        </template>
                    </Column>
                    <Column field="project_description" header="Description">
                        <template #body="slotProps">
                            {{slotProps.data.project_description}}
                        </template>
                    </Column>
                    <Column field="project_status" header="Status">
                        <template #body="slotProps">
                            <Button icon="pi pi-check" class="p-button-rounded p-button-success" v-if="slotProps.data.project_status == 'y'" />
                            <Button icon="pi pi-times" class="p-button-rounded p-button-danger" v-else/>
                        </template>
                    </Column>
					<Column header="Action">
						<template #body="slotProps">
                            <span class="p-buttonset">
                                <Button label="Edit Project" icon="pi pi-pencil" @click="editItem(slotProps.data)"/>
                                <!-- <Button label="Edit Outlet Type" icon="pi pi-external-link" @click="detailItem(slotProps.data.project_id,'outlet-type')"/> -->
                                <Button label="Edit Outlet" icon="pi pi-external-link" @click="detailItem(slotProps.data.project_id,'outlet')"/>
                                <Button label="Delete Project" icon="pi pi-trash"  class="p-button-danger" @click="deleteItem(slotProps.data)"/>
                            </span>
						</template>
					</Column>
                    <template #empty>
                        No data found.
                    </template>
                    <template #loading>
                        Loading data. Please wait.
                    </template>
                    <template #footer>
                        In total there are {{totalItemsCount ? totalItemsCount : 0 }} data.
                    </template>
                </DataTable>

                <Paginator v-model:rows="rows" v-model:first="offset" :totalRecords="totalItemsCount" :rowsPerPageOptions="[10,20,30]">
                    <template>
                        {{totalItemsCount}}
                    </template>
                </Paginator>

                <Edit @submit="getDataTable()" :item="item" ref="edit"/>

                <Delete @submit="getDataTable()" :item="item" ref="delete"/>
            </div>
      </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from "vuex";
import { numberingDatatable } from '../../utils/helpers';
import Create from '../../components/master/project/Create.vue';
import Edit from '../../components/master/project/Edit.vue';
import Delete from '../../components/master/project/Delete.vue';
import Error from '../../components/Error.vue';
import IndustryNotFoundComponent from '../../components/IndustryNotFoundComponent.vue';
import TagSlotComponent from '../../components/TagSlotComponent.vue';

export default {
    components: {
		'Create': Create,
		'Edit': Edit,
		'Delete': Delete,
		'Error': Error,
		'IndustryNotFoundComponent': IndustryNotFoundComponent,
		'TagSlotComponent': TagSlotComponent,
	},
    data() {
        return {
            // breadcrumb
            home: {icon: 'pi pi-home', to: '/'},
            items: [
                {label: 'Project'},
            ],

            // loading
            loading: false,
            loadingExcel: false,
            loadingCsv: false,

            // edit,delete
            item: {},
            
            //datatables
            data: null,
            dataTable: null,
            rows: 10,
            search: null,
            offset: null,
            field: null,
            sort: null,
            page: null,
            totalItemsCount: 0,
        }
    },
    mounted() {
        this.getDataTable();
        this.$store.commit('setErrors', {});
    },
    watch: {
        offset() {
            this.getDataTable();
        },
        rows() {
            this.getDataTable();
        },
    },
    computed:{
        ...mapGetters(['errors']),

		...mapGetters("auth", ["user"]),
    },
    methods: {
        formatDate(value){
            if (value) {
                return moment.utc(value).format('DD-MM-YYYY')
            }
        },
        // EDIT
		editItem(item) {
			this.item = item;
            
            this.$refs.edit.editItemDialog = true;
		},
        // DELETE
		deleteItem(item) {
			this.item = item;
            
            this.$refs.delete.deleteItemDialog = true;
		},
        // DETAIL
		detailItem(id, to) {
            if(to == 'outlet-type'){
                // this.$router.replace({ name: "project-outlet-type", params: {id:id} })
                alert('sorry page doesnt exist');
            }else if(to == 'outlet'){
                this.$router.replace({ name: "project-outlet", params: {id:id} })
            }else if(to == 'detail'){
                this.$router.replace({ name: "project-detail-salesman-calculation", params: {id:id} })
            }else{
                alert('sorry page doesnt exist');
            }
		},
        // DATATABLE
        getDataTable(){
          
            this.loading=true;
            // this.$refs.filter.loading = true;
            this.page = (this.offset / this.rows) + 1;

            this.axios({
                method: 'GET',
                url: process.env.VUE_APP_ROOT_API + 'web/project',
                params: {
                    "search" : this.search,
                    "per_page" : this.rows,
                    "page" : this.page,
                    "order_by" : this.field,
                    "sort_by" : this.sort,
                }
            })
            .then(res => {
              this.data = res.data.data.data;
              this.dataTable = numberingDatatable(res.data.data.data, this.page, this.rows);
              this.totalItemsCount = res.data.data.total;
              this.rows = parseInt(res.data.data.per_page);
              this.loading=false;
                // this.$refs.filter.loading = false;
            })
            .catch((err) => {
                console.log(err);
                this.loading=false;
                // this.$refs.filter.loading = false;
            });
         
        },
        onSort(event) {
            this.field = event.sortField;
            this.sort = event.sortOrder == '1' ? 'ASC' : 'DESC';
            this.getDataTable();
        },
        // EXPORT
        exportExcelCSV(ext){

            if(ext == 'xlsx'){
                this.loadingExcel=true;
            }else if(ext == 'csv'){
                this.loadingCsv=true;
            }

            this.axios({
            method: 'GET',
            url: process.env.VUE_APP_ROOT_API + 'web/project/export',
            responseType: 'blob',
            params: {
                "ext" : ext,
            }
            })
            .then(response => {
                let fileUrl = window.URL.createObjectURL(response.data);
                let fileLink = document.createElement('a');

                fileLink.href = fileUrl;

                fileLink.setAttribute('download', 'Project.' + ext);
                
                document.body.appendChild(fileLink)

                fileLink.click();
                
                if(ext == 'xlsx'){
                    this.loadingExcel=false;
                }else if(ext == 'csv'){
                    this.loadingCsv=false;
                }

            })
            .catch((err) => {
                console.log(err);
                
                if(ext == 'xlsx'){
                    this.loadingExcel=false;
                }else if(ext == 'csv'){
                    this.loadingCsv=false;
                }
            });
        },
    }
}
</script>
